import React from 'react'
import { Table, Typography } from 'antd'

import NextLink from 'next/link'

const columns = (broker1, broker2) => [
  {
    title: broker1.attributes.name,
    dataIndex: 'b1_comparision_link',
  },
  {
    title: broker2.attributes.name,
    dataIndex: 'b2_comparision_link',
  },
]

const generate_vs_link = (idx, broker, other_broker) => {
  const { name: broker_name, slug: broker_slug, country } = broker.attributes
  const {
    name: other_name,
    slug: other_slug,
    country: otherCountry,
  } = other_broker.attributes
  if (country.name !== otherCountry.name) return null
  return (
    <NextLink
      key={idx}
      href="/comparebroker/[slug]"
      as={
        broker_slug < other_slug
          ? `/comparebroker/${broker_slug}-vs-${other_slug}`
          : `/comparebroker/${other_slug}-vs-${broker_slug}`
      }
    >
      {`${broker_name} vs ${other_name}`}
    </NextLink>
  )
}

const dataSource = (broker1, broker2, all_brokers) => {
  return all_brokers
    .filter(
      (b) =>
        b.attributes.slug !== broker1.attributes.slug &&
        b.attributes.slug !== broker2.attributes.slug &&
        b.attributes.country?.name === broker1.attributes.country?.name &&
        b.attributes.country?.name === broker2.attributes.country?.name
    )
    .map((otherBroker, idx) => {
      return {
        b1_comparision_link: generate_vs_link(idx, broker1, otherBroker),
        b2_comparision_link: generate_vs_link(idx, broker2, otherBroker),
      }
    })
}

const TitleComp = (broker1, broker2) => {
  const { Title } = Typography
  const {
    attributes: { name: b1_name },
  } = broker1
  const {
    attributes: { name: b2_name },
  } = broker2

  return (
    <Title level={2}>
      Other Comparisons of {b1_name} and {b2_name}
    </Title>
  )
}

export default function CompareMoreBrokers({ brokers, all_brokers }) {
  const [broker1, broker2] = brokers

  return (
    <Table
      columns={columns(broker1, broker2)}
      dataSource={dataSource(broker1, broker2, all_brokers)}
      bordered
      title={() => TitleComp(broker1, broker2)}
      pagination={false}
    />
  )
}
